import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startHrmDocumentsTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description: "Giới thiệu các chức năng chính của thư viện tài liệu HRM.",
        side: "over",
        align: "center",
      },
    },
  ];
  const segments = [
    [
      '[data-tour="hrm-documents-header"]',
      "Tiêu đề trang",
      "Hiển thị tổng số tài liệu theo thư mục / bộ lọc hiện tại.",
      "bottom",
    ],
    [
      '[data-tour="hrm-documents-groups"]',
      "Nhóm tài liệu",
      "Cây thư mục bên trái — chọn nhóm để lọc tài liệu trong thư viện.",
      "right",
    ],
    [
      '[data-tour="hrm-documents-filter"]',
      "Bộ lọc tài liệu",
      "Tìm kiếm, lọc trạng thái/ngày và mở form thêm mới.",
      "bottom",
    ],
    [
      '[data-tour="hrm-documents-grid"]',
      "Danh sách tài liệu",
      "Các thẻ tài liệu trong nhóm đang chọn; bấm thẻ để mở chi tiết.",
      "top",
    ],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({
    showProgress: true,
    smoothScroll: true,
    popoverClass: "hrm-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    steps,
  }).drive();
}
